// extracted by mini-css-extract-plugin
module.exports = {"container":"vs__container___1MAF8"};